import { createGlobalStyle } from 'styled-components';

const colors = {
  global: {
    background: ({ theme }) => theme.global.background,
    text: ({ theme }) => theme.global.text,
    accent: ({ theme }) => theme.global.accent,
    indicators: ({ theme }) => theme.global.indicators,
    container: ({ theme }) => theme.global.container,
    transparent: ({ theme }) => theme.global.transparent,
  },
  forms: {
    background: ({ theme }) => theme.forms.background,
    bgSolid: ({ theme }) => theme.forms.backgroundSolid,
    disabledBg: ({ theme }) => theme.forms.disabledBackground,
    border: ({ theme }) => theme.forms.border,
    text: ({ theme }) => theme.forms.text,
    disabledText: ({ theme }) => theme.forms.disabledText,
    shadow: ({ theme }) => theme.forms.shadow,
    invalid: ({ theme }) => theme.forms.invalid,
    invalidIcon: ({ theme }) => theme.forms.invalidIcon,
    invalidShadow: ({ theme }) => theme.forms.invalidShadow,
    valid: ({ theme }) => theme.forms.valid,
    validShadow: ({ theme }) => theme.forms.validShadow,
    validIcon: ({ theme }) => theme.forms.validIcon,
    pending: ({ theme }) => theme.forms.pending,
    muted: ({ theme }) => theme.forms.mutedText,
    kebabMenu: ({ theme }) => theme.forms.kebabMenu,
    credentialStep: ({ theme }) => theme.forms.credentialStep,
    timePicker: ({ theme }) => theme.forms.timePicker,
    clearIcon: ({ theme }) => theme.forms.clearIcon,
  },
  buttons: {
    primary: {
      background: ({ theme }) => theme.buttons.primary.background,
      text: ({ theme }) => theme.buttons.primary.text,
      shadow: ({ theme }) => theme.buttons.primary.shadow,
    },
    secondary: {
      background: ({ theme }) => theme.buttons.secondary.background,
      text: ({ theme }) => theme.buttons.secondary.text,
      shadow: ({ theme }) => theme.buttons.secondary.shadow,
    },
    success: {
      background: ({ theme }) => theme.buttons.success.background,
      text: ({ theme }) => theme.buttons.success.text,
      shadow: ({ theme }) => theme.buttons.success.shadow,
    },
    light: {
      background: ({ theme }) => theme.buttons.light.background,
      text: ({ theme }) => theme.buttons.light.text,
      shadow: ({ theme }) => theme.buttons.light.shadow,
    },
    danger: {
      background: ({ theme }) => theme.buttons.danger.background,
      text: ({ theme }) => theme.buttons.danger.text,
      shadow: ({ theme }) => theme.buttons.danger.shadow,
    },
  },
  alerts: {
    warning: {
      background: ({ theme }) => theme.alerts.warning.background,
      text: ({ theme }) => theme.alerts.warning.text,
      border: ({ theme }) => theme.alerts.warning.border,
    },
    danger: {
      background: ({ theme }) => theme.alerts.danger.background,
      text: ({ theme }) => theme.alerts.danger.text,
      border: ({ theme }) => theme.alerts.danger.border,
    },
  },
};

export const Theme = createGlobalStyle`
 body {
    background: ${colors.global.background};
    color: ${colors.global.text};
    background-repeat: no-repeat;
    background-attachment: fixed;
}

a {
    color: ${colors.global.accent};
}

.card {
    background-color: ${colors.global.container};
}

.form-group {
    border-bottom: ${colors.forms.border};
    select,
    select>option,
    select:focus {
        background-color: ${colors.forms.bgSolid};
        color: ${colors.global.text};
    }
}

.bordered-fieldset {
    border: ${colors.forms.border};
}

.rbt {
    .dropdown-menu {
        background-color: ${colors.forms.bgSolid};
        a {
            color: ${colors.global.text};
        }
        a:hover, a:focus {
            background-color: ${colors.global.transparent};
        }
    }
    .rbt-highlight-text {
        background-color: ${colors.global.accent};
        color: ${colors.forms.bgSolid};
    }
}

.form-control,
.form-control:focus,
.custom-file-label {
    background-color: ${colors.forms.bgSolid};
    border: ${colors.forms.border};
    color: ${colors.forms.text};
    &:disabled {
        background-color: ${colors.forms.disabledBg};
        color: ${colors.forms.disabledText};
    }
    &::placeholder {
        color: ${colors.global.text};
        background-color: ${colors.global.transparent};
    }
}

input[type="time"].form-control::-webkit-calendar-picker-indicator {
    filter: ${colors.forms.timePicker};
}

.custom-file-label {
    &:after {
        background-color: ${colors.buttons.primary.background};
        border: ${colors.buttons.primary.background};
        color: ${colors.buttons.primary.text};
    }
    &:focus {
        box-shadow: ${colors.forms.shadow};
    }
}

.form-control:focus {
    box-shadow: ${colors.forms.shadow};
}

.was-validated .form-control,
.was-validated .custom-file-input {
    &:invalid,
    &:invalid:focus,
    &:invalid~.custom-file-label {
        border-color: ${colors.forms.invalid};
        background-image: url("${colors.forms.invalidIcon}");
    }
    &:valid,
    &:valid:focus,
    &:valid~.custom-file-label {
        border-color: ${colors.forms.valid};
        background-image: url("${colors.forms.validIcon}");
    }
    &:invalid:focus,
    &:invalid:focus~.custom-file-label {
        box-shadow: ${colors.forms.invalidShadow};
        border-color: ${colors.forms.invalid};
    }
    &:valid:focus,
    &:valid:focus~.custom-file-label {
        box-shadow: ${colors.forms.validShadow};
        border-color: ${colors.forms.valid};
    }
}

.was-validated .custom-file-input {
    &:invalid,
    &:invalid~.custom-file-label,
    &:valid,
    &:valid~.custom-file-label{
        background-image: none;
    }
}

.form-control.is-invalid {
    border-color: ${colors.forms.invalid};
}

.invalid-feedback,
.text-color-warning {
    color: ${colors.forms.invalid};
}

.text-color-success{
    color: ${colors.forms.valid};
}

.text-color-pending{
    color: ${colors.forms.pending};
}

.muted-text {
        color: ${colors.forms.muted};
}

.svg-icon{
    .error-icon{
        fill: ${colors.forms.invalid};
    }

    .checked-icon{
        fill: ${colors.forms.valid};
    }

    .checked-bg{
        fill: ${global.transparent};
    }

    .pending-icon{
        fill: ${colors.forms.pending};
    }
}

.alert.alert-warning {
    color: ${colors.alerts.warning.text};
    background-color: ${colors.alerts.warning.background};
    border: ${colors.alerts.warning.border};
}

.alert.alert-danger {
    color: ${colors.alerts.danger.text};
    background-color: ${colors.alerts.danger.background};
    border: ${colors.alerts.danger.border};
}

.custom-switch-wrapper {
    background-color: ${colors.global.container};
    border: ${colors.forms.border};
    a {
        color: ${colors.global.accent}
    }
    .custom-control {
        background-color: ${colors.global.transparent};
    }
    .custom-control-input:checked~.custom-control-label::before {
        border: ${colors.buttons.primary.background};
        background-color: ${colors.buttons.primary.background};
    }
}

.custom-control-input.is-valid:checked~.custom-control-label::before,
.was-validated .custom-control-input:valid:checked~.custom-control-label::before{
    border: ${colors.forms.valid};
    background-color: ${colors.forms.valid};
}

.btn {
    &.btn-primary,
    &.btn-primary:focus,
    &.btn-primary:not(.disabled):active {
        background-color: ${colors.buttons.primary.background};
        border-color: ${colors.buttons.primary.background};
        color: ${colors.buttons.primary.text};
    }
    &.btn-primary:focus {
        box-shadow: ${colors.buttons.primary.shadow};
    }
    &.btn-secondary,
    &.btn-secondary:focus,
    &.btn-secondary:not(.disabled):active {
        background-color: ${colors.buttons.secondary.background};
        border-color: ${colors.buttons.secondary.background};
        color: ${colors.buttons.secondary.text};
    }
    &.btn-secondary:focus {
        box-shadow: ${colors.buttons.secondary.shadow};
    }
    &.btn-light,
    &.btn-light:focus,
    &.btn-light:not(.disabled):active {
        background-color: ${colors.buttons.light.background};
        border-color: ${colors.buttons.light.background};
        color: ${colors.buttons.light.text};
    }
    &.btn-light:focus {
        box-shadow: ${colors.buttons.light.shadow};
    }
    &.btn-success,
    &.btn-success:focus,
    &.btn-success:not(.disabled):active {
        background-color: ${colors.buttons.success.background};
        border-color: ${colors.buttons.success.background};
        color: ${colors.buttons.success.text};
    }
    &.btn-success:focus {
        box-shadow: ${colors.buttons.success.shadow};
    }
    &.btn-danger,
    &.btn-danger:focus,
    &.btn-danger:not(.disabled):active {
        background-color: ${colors.buttons.danger.background};
        border-color: ${colors.buttons.danger.background};
        color: ${colors.buttons.danger.text};
    }
    &.btn-danger:focus {
        box-shadow: ${colors.buttons.danger.shadow};
    }
}

div.kebab-menu {
    .menu-content {
        background-color: ${colors.forms.bgSolid};
    }
    .dot {
        background-color: ${colors.forms.kebabMenu};
    }
}

.list-group-item {
    background-color: ${colors.global.transparent};
}

.trip-summary,
.passenger-link,
.border-bottom-default,
.card-text {
    border: none;
    border-bottom: ${colors.forms.border};
}

.credential-box {
    border-top: ${colors.forms.border};
    color: ${colors.forms.text};
    .credential-step {
        color: ${colors.forms.credentialStep};
    }
}

.modal-content {
    background-color: ${colors.forms.bgSolid};
}

.manage-checklist{
    color: ${colors.global.accent};
}

.rbt-aux .rbt-close{
    color: ${colors.global.text};
}

.test-details-wrapper {
    background: ${colors.global.background};
}

[data-reach-combobox-popover] {
    background: ${colors.forms.bgSolid};
}

.carousel-component-wrapper {
    background: ${colors.global.background};
    color: ${colors.global.indicators};
    .carousel-indicators {
        li {
            background: ${colors.global.indicators};
        }
    }
}
`;
